import React from "react";

export type PixelRunnerState = "idle" | "run" | "jump";

type PixelRunnerProps = {
  state: PixelRunnerState;
  facing?: "down" | "up";
  reducedMotion?: boolean;
  className?: string;
};

const SHEET = `${import.meta.env.BASE_URL}game/player.png`;

/**
 * The game's player sprite (public/game/player.png). Decorative only — states driven by scroll guide.
 */
const PixelRunner: React.FC<PixelRunnerProps> = ({
  state,
  facing = "down",
  reducedMotion = false,
  className = "",
}) => {
  const animState = reducedMotion ? "idle" : state;
  const faceClass = facing === "up" ? "pixel-runner--face-up" : "";

  return (
    <div
      className={`pixel-runner pixel-runner--${animState} ${faceClass} ${className}`.trim()}
      aria-hidden
    >
      <div
        className="pixel-runner__sprite"
        style={{ backgroundImage: `url(${SHEET})` }}
      />
    </div>
  );
};

export default PixelRunner;
